import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "flex flex-row justify-between items-center"
};
const _hoisted_2 = {
  class: "py-4 px-4 flex flex-row"
};
const _hoisted_3 = {
  class: "w-1/2 pr-2"
};
const _hoisted_4 = {
  class: "flex flex-row justify-between items-center"
};
import { reactive, computed } from 'vue';
import { useInvoiceEmailStore } from '@/modules/settings/company/InvoiceEmail/useInvoiceEmailStore.js';
import { useMeStore } from '@/services/UserService/useMeStore';
import { storeToRefs } from 'pinia';
import LlTextField from '@/components/LlTextField.vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useSupportChat } from '@/composables/useSupportChat';
import { senderNameOrCompanyName } from '@/utils/senderNameValidation';
const noSenderNameMessage = "Your firm name can't be used as the sender name. Set a sender name in Email Settings.";
export default {
  __name: 'MissingSenderEmailModel',
  props: {
    state: {
      type: Object,
      required: true
    },
    stateParams: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    },
    emailCustomizationState: {
      type: Object,
      required: true
    }
  },
  emits: ['updateSenderEmail'],
  setup(__props, {
    emit: __emit
  }) {
    const {
      getSupportUrl
    } = useSupportChat();
    const props = __props;
    const missingSenderEmailState = reactive({
      addMissingEmailDialog: true,
      updateMissingEmailDialog: true,
      senderEmail: ''
    });
    const emit = __emit;
    const invoiceEmailStore = useInvoiceEmailStore();
    invoiceEmailStore.alerts = props.alerts;
    const {
      me
    } = storeToRefs(useMeStore());

    // This dialog has no name field, so a stored name the API would reject can't be fixed here.
    const senderName = () => senderNameOrCompanyName(invoiceEmailStore.invoiceDelivery.fromName, me.value?.company?.name);
    const save = async () => {
      if (!validEmail.value) {
        props.alerts?.error('Please enter a valid email');
        return;
      } else {
        await invoiceEmailStore.getInvoiceDeliveryDetail();
        const fromName = senderName();
        if (!fromName) {
          props.alerts?.error(noSenderNameMessage);
          return;
        }
        const saved = await invoiceEmailStore.sentInvoiceDeliveryDetail({
          subject: invoiceEmailStore.invoiceDelivery.subject,
          reminderSubject: invoiceEmailStore.invoiceDelivery.reminderSubject,
          trustRequestSubject: invoiceEmailStore.invoiceDelivery.trustRequestSubject,
          body: invoiceEmailStore.invoiceDelivery.body,
          reminderBody: invoiceEmailStore.invoiceDelivery.reminderBody,
          trustRequestBody: invoiceEmailStore.invoiceDelivery.trustRequestBody,
          fromEmail: missingSenderEmailState.senderEmail,
          fromName,
          buttonColor: invoiceEmailStore.invoiceDelivery.buttonColor,
          enabled: invoiceEmailStore.invoiceDelivery.enabled,
          modules: invoiceEmailStore.invoiceDelivery.modules
        });
        if (!saved) return;
        emit('updateSenderEmail', missingSenderEmailState.senderEmail);
        missingSenderEmailState.addMissingEmailDialog = false;
      }
    };
    const saveAndGoToEmailSettings = async () => {
      if (!validEmail.value) {
        props.alerts?.error('Please enter a valid email');
        return;
      } else {
        missingSenderEmailState.addMissingEmailDialog = false;
        await invoiceEmailStore.getInvoiceDeliveryDetail();
        const fromName = senderName();
        // Email Settings is where a missing sender name gets fixed, so still go there.
        if (!fromName) {
          props.alerts?.error(noSenderNameMessage);
        } else {
          await invoiceEmailStore.sentInvoiceDeliveryDetail({
            subject: invoiceEmailStore.invoiceDelivery.subject,
            reminderSubject: invoiceEmailStore.invoiceDelivery.reminderSubject,
            trustRequestSubject: invoiceEmailStore.invoiceDelivery.trustRequestSubject,
            body: invoiceEmailStore.invoiceDelivery.body,
            reminderBody: invoiceEmailStore.invoiceDelivery.reminderBody,
            trustRequestBody: invoiceEmailStore.invoiceDelivery.trustRequestBody,
            fromEmail: missingSenderEmailState.senderEmail,
            fromName,
            buttonColor: invoiceEmailStore.invoiceDelivery.buttonColor,
            enabled: invoiceEmailStore.invoiceDelivery.enabled,
            modules: invoiceEmailStore.invoiceDelivery.modules
          });
        }
        // Open in a new tab instead of navigating in the current tab
        window.open('#/settings/company/invoiceEmail', '_blank');
      }
    };
    const validEmail = computed(() => {
      const email = missingSenderEmailState.senderEmail;
      if (email) {
        return email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
      }
      return false;
    });
    function learnMore() {
      window.open(getSupportUrl('emailServiceSetup'), '_blank');
    }
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_divider = _resolveComponent("v-divider");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createBlock(_component_v_container, null, {
        default: _withCtx(() => [_unref(me)?.access?.setup ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          justify: "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_dialog, {
            modelValue: missingSenderEmailState.addMissingEmailDialog,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => missingSenderEmailState.addMissingEmailDialog = $event),
            width: "700"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_v_card_title, {
                class: "card-title"
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("Missing Sender Email", -1)]))]),
                _: 1
              }), _createVNode(_component_v_icon, {
                class: "mr-4",
                onClick: _cache[0] || (_cache[0] = $event => missingSenderEmailState.addMissingEmailDialog = false)
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("mdi-close", -1)]))]),
                _: 1
              })]), _createVNode(_component_v_divider), _cache[12] || (_cache[12] = _createElementVNode("div", {
                class: "p-4 text-sm text-gray-800"
              }, " Your firm doesn't have a sender or reply to email yet. Add it now to start sending invoice emails from LeanLaw. Go to Email Settings to configure additional settings like the logo and template. ", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(LlTextField, {
                type: "text",
                density: "compact",
                variant: "outlined",
                color: "primary",
                modelValue: missingSenderEmailState.senderEmail,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => missingSenderEmailState.senderEmail = $event),
                placeholder: "Sender Email"
              }, null, 8, ["modelValue"])])]), _createVNode(_component_v_card_actions, {
                class: "flex flex-1 justify-end bg-gray-50"
              }, {
                default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_v_container, null, {
                  default: _withCtx(() => [_createVNode(_component_v_row, {
                    justify: "end",
                    align: "end"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_col, {
                      cols: "auto"
                    }, {
                      default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                        variant: "outlined",
                        onClick: _cache[2] || (_cache[2] = $event => missingSenderEmailState.addMissingEmailDialog = false)
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Close ", -1)]))]),
                        _: 1
                      })]),
                      _: 1
                    }), _createVNode(_component_v_col, {
                      cols: "auto"
                    }, {
                      default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                        variant: "outlined",
                        onClick: saveAndGoToEmailSettings
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Save & go to Email Settings ", -1)]))]),
                        _: 1
                      })]),
                      _: 1
                    }), _createVNode(_component_v_col, {
                      cols: "auto"
                    }, {
                      default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                        variant: "flat",
                        color: "primary",
                        onClick: save
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("Save", -1)]))]),
                        _: 1
                      })]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), !_unref(me)?.access?.setup ? (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          justify: "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_dialog, {
            modelValue: missingSenderEmailState.updateMissingEmailDialog,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => missingSenderEmailState.updateMissingEmailDialog = $event),
            width: "700"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_v_card_title, {
                class: "card-title"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("Missing Sender Email", -1)]))]),
                _: 1
              }), _createVNode(_component_v_icon, {
                class: "mr-4",
                onClick: _cache[4] || (_cache[4] = $event => missingSenderEmailState.updateMissingEmailDialog = false)
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("mdi-close", -1)]))]),
                _: 1
              })]), _createVNode(_component_v_divider), _cache[17] || (_cache[17] = _createElementVNode("div", {
                class: "p-4 text-sm text-gray-800"
              }, " Your firm is missing a sender or reply to email. Please reach out to someone in your firm with access to firm settings to update it in Settings > Email Settings to start sending invoice emails from LeanLaw. ", -1)), _createVNode(_component_v_card_actions, {
                class: "flex flex-1 justify-end bg-gray-50"
              }, {
                default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_v_container, null, {
                  default: _withCtx(() => [_createVNode(_component_v_row, {
                    justify: "end",
                    align: "end"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_col, {
                      cols: "auto"
                    }, {
                      default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                        variant: "outlined",
                        onClick: _cache[5] || (_cache[5] = $event => missingSenderEmailState.updateMissingEmailDialog = false)
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" Ok ", -1)]))]),
                        _: 1
                      })]),
                      _: 1
                    }), _createVNode(_component_v_col, {
                      cols: "auto"
                    }, {
                      default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                        variant: "flat",
                        color: "primary",
                        onClick: learnMore
                      }, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode(" Learn More", -1)]))]),
                        _: 1
                      })]),
                      _: 1
                    })]),
                    _: 1
                  })]),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};